const colors =  {
    backdropBackground: 'rgba(41,41,41,0.70)',
    borderBottomColor: '#2F2F2F'
}


export default colors;
